import React, { useState } from 'react';
import { Container, Box, Typography, TextField, Button, Paper, Divider, useTheme, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Link } from 'react-router-dom';

import GoogleIconImage from '../assets/google_icon.png'; 

export const Signup = () => {
    const theme = useTheme();
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        password: '',
        confirmPassword: '',
    });
    const [showPassword, setShowPassword] = useState(false); // State for password visibility

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (e) => {
        e.preventDefault();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Signup Data:", formData);
        // Add your Firebase/Backend signup logic here
    };

    // Helper function for the password adornment
    const PasswordAdornment = (
        <InputAdornment position="end">
            <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
            >
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );

    return (
        <Container maxWidth="xs" sx={{ pt: 8, pb: 4, minHeight: 'calc(100vh - 64px)', bgcolor: theme.palette.background.default }}>
            <Paper elevation={4} sx={{ p: 4, borderRadius: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                
                {/* Header Section */}
                <Typography variant="h5" component="h1" sx={{ fontWeight: 600, mb: 0.5, color: theme.palette.text.primary }}>
                    
                </Typography>
                <Typography variant="h5" component="h2" sx={{ fontWeight: 700, mb: 1.5, color: theme.palette.primary.main }}>
                    Create Account
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Join the community to personalize your experience.
                </Typography>

                {/* Google Sign Up Button */}
                <Button
                    variant="outlined"
                    fullWidth
                    startIcon={<img src={GoogleIconImage} alt="Google" style={{ width: 24, height: 24 }} />}
                    sx={{ 
                        mb: 3, 
                        py: 1.5, 
                        borderColor: theme.palette.text.primary, 
                        color: theme.palette.text.primary,
                        '&:hover': {
                            borderColor: theme.palette.primary.main,
                            color: theme.palette.primary.main
                        }
                    }}
                    onClick={() => console.log("Sign up with Google")}
                >
                    Sign Up with Google
                </Button>

                {/* Divider */}
                <Divider sx={{ width: '100%', mb: 3 }}>
                    <Typography variant="caption" color="text.secondary">
                        OR Sign Up with email
                    </Typography>
                </Divider>

                {/* Email Form */}
                <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        required
                        fullWidth
                        label="Full Name"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        variant="outlined"
                    />
                    <TextField
                        required
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        variant="outlined"
                    />
                    
                    {/* Password Field with Hide/Show Toggle */}
                    <TextField
                        required
                        fullWidth
                        label="Password"
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        value={formData.password}
                        onChange={handleChange}
                        variant="outlined"
                        InputProps={{ endAdornment: PasswordAdornment }}
                    />
                    
                    {/* Confirm Password Field with Hide/Show Toggle */}
                    <TextField
                        required
                        fullWidth
                        label="Confirm Password"
                        name="confirmPassword"
                        type={showPassword ? 'text' : 'password'}
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        variant="outlined"
                        InputProps={{ endAdornment: PasswordAdornment }}
                    />
                    
                    {/* Sign Up Button */}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        color="primary"
                        sx={{ mt: 2, py: 1.5 }}
                    >
                        Sign Up
                    </Button>
                </Box>
                
                {/* Login Link */}
                <Typography variant="body2" sx={{ mt: 3 }}>
                    Already have an account? 
                    <Link to="/login" style={{ color: theme.palette.secondary.main, textDecoration: 'none', fontWeight: 600, marginLeft: 4 }}>
                        Login here
                    </Link>
                </Typography>

            </Paper>
        </Container>
    );
};